export default "__VITE_ASSET__cZPGy_bd__"